/**
 * Validates the `$id` route param of the `/users/$id` family. Each route that
 * loads user data guards with it independently (the layout and edit loaders
 * run in parallel, so neither may assume the other already rejected a bad id).
 */
export function parseUserId(raw: string): number | null {
  const id = Number(raw);
  return Number.isInteger(id) && id > 0 ? id : null;
}
